
export default function AboutSection() {
  const coreValues = [
    {
      icon: 'ri-team-line',
      number: '01',
      title: '연합 (Unity)',
      subtitle: '영적인 네트워킹',
      description: '우리는 고립되지 않고 연결됩니다. 그리스도 안에서 서로 연합하여 영적 네트워킹을 이루고, 함께할 때 더 큰 하나님 나라의 역사를 만들어 갑니다.'
    },
    {
      icon: 'ri-heart-line',
      number: '02',
      title: '헌신 (Dedication)',
      subtitle: '부르심과 소명',
      description: '우리는 하나님의 부르심 앞에 머뭇거리지 않습니다. 각자에게 주어진 소명을 깨닫고, 자발적인 순종과 헌신으로 사역의 현장을 섬깁니다.'
    },
    {
      icon: 'ri-music-line',
      number: '03',
      title: '예배 (Worship)',
      subtitle: '하나님의 성품으로 회복',
      description: '사역보다 중요한 것은 예배자의 마음입니다. 우리는 잃어버린 하나님의 성품을 회복하며, 삶의 모든 자리에서 하나님을 온전히 예배합니다.'
    },
    {
      icon: 'ri-global-line',
      number: '04',
      title: '하나님 나라 (Kingdom of God)',
      subtitle: '지상명령 성취',
      description: '우리의 시선은 땅끝을 향합니다. 예수님의 지상명령을 최우선 가치로 삼아, 이 땅에 하나님 나라가 임하게 하는 일에 전력합니다.'
    }
  ];

  return (
    <section id="about" className="py-12 sm:py-16 md:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            킹덤브릿지미션
          </h2>
          <div className="text-sm sm:text-base md:text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed space-y-3 sm:space-y-4">
            <p className="font-semibold text-teal-700">
              KINGDOM BRIDGE MISSION
            </p>
            <p>
              킹덤브릿지미션은 그리스도의 몸 된 지체들이 연합하여 성전을 이루는 믿음의 공동체입니다.
            </p>
            <p>
              우리는 그리스도가 필요한 나라와 도시, 교회와 이웃에게 하나님 나라를 전하며, 
              영적인 돌봄이 필요한 곳을 잇는 <strong className="text-teal-700">'거룩한 다리'</strong>가 됩니다.
            </p>
            <p className="hidden sm:block">
              우리의 헌신과 영적 네트워킹을 통해 하나님 나라의 거점을 세우고, 
              마침내 모든 열방과 백성이 하나님을 예배하게 하는 것, 이것이 우리의 사명입니다.
            </p>
          </div>
        </div>

        {/* Core Values Title */}
        <div className="text-center mb-8 sm:mb-12">
          <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-2 sm:mb-3">
            핵심 가치
          </h3>
          <p className="text-sm sm:text-base md:text-lg text-teal-600 font-semibold">Core Values</p>
        </div>

        {/* Core Values Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-8 mb-10 sm:mb-16">
          {coreValues.map((value, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-6 md:p-8 shadow-lg hover:shadow-xl transition-all"
            >
              <div className="flex items-start gap-3 sm:gap-4 md:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-teal-100 rounded-full flex items-center justify-center mb-1 sm:mb-2">
                    <i className={`${value.icon} text-xl sm:text-2xl md:text-3xl text-teal-600`}></i>
                  </div>
                  <div className="text-center text-lg sm:text-xl md:text-2xl font-bold text-teal-600">{value.number}</div>
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-1">
                    {value.title}
                  </h4>
                  <p className="text-xs sm:text-sm font-semibold text-teal-600 mb-2 sm:mb-3">
                    {value.subtitle}
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Image Gallery */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mt-10 sm:mt-16">
          <div className="relative h-48 sm:h-64 md:h-80 rounded-xl sm:rounded-2xl overflow-hidden shadow-lg">
            <img 
              src="https://public.readdy.ai/ai/img_res/ca0816d71133c4a293bd31bd0b18f48d.jpg"
              alt="연합과 영적 네트워킹"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative h-48 sm:h-64 md:h-80 rounded-xl sm:rounded-2xl overflow-hidden shadow-lg">
            <img 
              src="https://readdy.ai/api/search-image?query=missionary%20serving%20with%20dedication%20in%20community%20outreach%2C%20helping%20local%20people%20with%20compassionate%20care%2C%20natural%20lighting%20showing%20sincere%20devotion%20and%20calling%2C%20warm%20tones%20emphasizing%20commitment%20to%20mission%20work%2C%20authentic%20documentary%20photography%20style&width=600&height=800&seq=about-img-dedication&orientation=portrait"
              alt="헌신과 소명"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative h-48 sm:h-64 md:h-80 rounded-xl sm:rounded-2xl overflow-hidden shadow-lg">
            <img 
              src="https://readdy.ai/api/search-image?query=people%20from%20different%20nations%20worshiping%20God%20together%20with%20raised%20hands%20in%20joyful%20praise%2C%20diverse%20multicultural%20congregation%2C%20bright%20uplifting%20atmosphere%2C%20golden%20hour%20lighting%2C%20capturing%20the%20beauty%20of%20global%20worship%20and%20Kingdom%20of%20God%20vision%2C%20inspirational%20photography&width=600&height=800&seq=about-img-worship&orientation=portrait"
              alt="예배와 하나님 나라"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
